/**
 * Hostnames that must 301-style to the canonical apex.
 * www must also be connected in Firebase Hosting (Console) or it never reaches us.
 */
export const CANONICAL_HOST = 'veraelegance.com';

export const LEGACY_HOSTS = new Set([
  'www.veraelegance.com',
  'vera-by-kamakshi.web.app',
  'vera-by-kamakshi.firebaseapp.com'
]);

export function getCanonicalOrigin() {
  return `https://${CANONICAL_HOST}`;
}

/**
 * If we're on www or the old *.web.app host, jump to the apex with the same path.
 * Prefer connecting www in Firebase with "Redirect to veraelegance.com" for a true 301.
 */
export function redirectToCanonicalHost() {
  if (typeof window === 'undefined') return false;

  const { hostname, pathname, search, hash } = window.location;
  if (!LEGACY_HOSTS.has(hostname)) return false;

  const target = `${getCanonicalOrigin()}${pathname}${search}${hash}`;
  window.location.replace(target);
  return true;
}

/**
 * Build unique product SEO fields from product data.
 */
export function buildProductSeo(product, siteName = 'VERA by Kamakshi') {
  const name = (product?.name || 'Luxury Bag').trim();
  const category = (product?.category || '').trim();
  const material = (product?.material || '').trim();
  const price = Number(product?.salePrice || product?.price);
  const priceText = Number.isFinite(price) && price > 0
    ? `₹${Math.round(price).toLocaleString('en-IN')}`
    : '';

  const titleParts = [name];
  if (category) titleParts.push(category);
  titleParts.push(siteName);
  const title = titleParts.join(' | ');

  const rawDescription = (product?.description || '').replace(/\s+/g, ' ').trim();
  let description;
  if (rawDescription.length >= 40) {
    const suffixBits = [
      priceText ? `Price ${priceText}.` : null,
      'Modern Everyday Luxury from VERA by Kamakshi.'
    ].filter(Boolean);
    const combined = `${rawDescription}${rawDescription.endsWith('.') ? '' : '.'} ${suffixBits.join(' ')}`.trim();
    description = combined.length > 160
      ? `${combined.slice(0, 157).trim()}...`
      : combined;
  } else {
    const bits = [
      `Buy ${name}`,
      category ? `in ${category}` : null,
      material ? `featuring ${material}` : null,
      'from VERA by Kamakshi',
      priceText ? `— ${priceText}` : null,
      'Modern Everyday Luxury. Free shipping across India.'
    ].filter(Boolean);
    description = bits.join(' ');
    if (description.length > 160) {
      description = `${description.slice(0, 157).trim()}...`;
    }
  }

  const keywords = [
    name,
    category,
    material,
    'luxury handbag',
    'VERA by Kamakshi',
    'Modern Everyday Luxury'
  ].filter(Boolean).join(', ');

  return { title, description, keywords };
}
